import React from 'react';
import { FadeIn } from './FadeIn';
import { Leaf, Minus } from 'lucide-react';
export function TargetAudience() {
  const isFor = ['Madres y padres que anhelan ver a sus hijos dormir en paz y sin temor.', 'Matrimonios que desean reemplazar el sarcasmo por palabras de gracia.', 'Familias que acaban de mudarse o sienten que su casa actual está "bloqueada".', 'Creyentes que desean ejercer su sacerdocio espiritual con sabiduría y amor.'];
  const isNotFor = ['Quienes buscan soluciones mágicas sin compromiso de cambio personal.', 'Personas que no creen en la autoridad de la Palabra de Dios.'];
  return <section className="py-24 px-6 bg-cream-50" data-id="element-158">
      <div className="max-w-5xl mx-auto grid md:grid-cols-2 gap-12 md:gap-8" data-id="element-159">
        <FadeIn data-id="element-160">
          <div className="bg-white p-8 rounded-2xl shadow-lg border-t-4 border-olive-500 h-full" data-id="element-161">
            <h2 className="text-2xl md:text-3xl font-bold mb-8 text-brown-900" data-id="element-162">
              Para quién es esto
            </h2>
            <ul className="space-y-6" data-id="element-163">
              {isFor.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-164">
                  <Leaf className="w-6 h-6 text-olive-500 flex-shrink-0 mt-1" data-id="element-165" />
                  <span className="text-lg text-brown-800" data-id="element-166">{item}</span>
                </li>)}
            </ul>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-167">
          <div className="bg-cream-100 p-8 rounded-2xl border border-cream-200 h-full opacity-90" data-id="element-168">
            <h2 className="text-2xl md:text-3xl font-bold mb-8 text-brown-800/70" data-id="element-169">
              Para quién NO es
            </h2>
            <ul className="space-y-6" data-id="element-170">
              {isNotFor.map((item, index) => <li key={index} className="flex items-start gap-4" data-id="element-171">
                  <Minus className="w-6 h-6 text-brown-400 flex-shrink-0 mt-1" data-id="element-172" />
                  <span className="text-lg text-brown-700/80" data-id="element-173">{item}</span>
                </li>)}
            </ul>
          </div>
        </FadeIn>
      </div>
    </section>;
}